import { useParams, useRouteLoaderData } from 'react-router-dom';
import { LoginResponseDto, PermissionModel } from '../lib/ServerApi';

export type Permission = `${PermissionModel['permissionArea']}:${PermissionModel['PermissionAction']}`;

export const useGuard = (permission: Permission) => {
    const [page] = permission.split(':') as [PermissionModel['permissionArea'], PermissionModel['PermissionAction']];
    const { scope } = useRouteLoaderData('root') as LoginResponseDto;
    const { branchId } = useParams() as { branchId: string };
    if (scope?.organization?.length) {
        return true;
    }

    if (branchId) {
        const branch = scope?.branches.find((b) => b.id === branchId);
        if (!branch) {
            return false;
        }
        return branch.access.some((scope) => {
            return scope === permission || scope === `${page}:*` || scope === '*:*';
        });
    }

    const result = scope?.branches.some((branch) => {
        return branch.access.some((scope) => {
            return scope === permission || scope === `${page}:*` || scope === '*:*';
        });
    });

    return result;
};

export const useGuardAny = (permissions: Permission[]) => {
    const { scope } = useRouteLoaderData('root') as LoginResponseDto;
    const { branchId } = useParams() as { branchId: string };

    if (scope?.organization?.length) {
        return true;
    }

    if (!permissions.length) {
        return false;
    }

    const requiredAccess = new Set<string>(['*:*']);
    permissions.forEach((permission) => {
        const [page] = permission.split(':') as [PermissionModel['permissionArea'], PermissionModel['PermissionAction']];
        requiredAccess.add(permission);
        requiredAccess.add(`${page}:*`);
    });

    if (branchId) {
        const branch = scope?.branches.find((b) => b.id === branchId);
        if (!branch) {
            return false;
        }

        return branch.access.some((scope) => requiredAccess.has(scope));
    }

    const result = scope?.branches.some((branch) => {
        return branch.access.some((scope) => requiredAccess.has(scope));
    });

    return result;
};
